export default __webpack_public_path__ + "static/media/radio-uncheck.66dbc60e.svg";